module.exports = __webpack_public_path__ + "static/media/TaskManagement_admin_003.a5c9196b.png";